export default __webpack_public_path__ + "static/media/11_ALoveStoryII.ba2c0703.jpg";